









































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { PlusIcon, CheckSquareIcon, SquareIcon, ClockIcon } from 'vue-feather-icons';
import VueApexCharts from 'vue-apexcharts';
import { IAgency, ITask, ITaskCountsResult, TaskStatus } from 'admiral-core';
import dayjs from 'dayjs';

@Component({
  components: {
    PlusIcon,
    CheckSquareIcon,
    SquareIcon,
    ClockIcon,
    apexchart: VueApexCharts,
  },
})
export default class NewTasksCard extends Vue {
  @Prop({ type: String, required: true }) title!: string;
  @Prop({ type: String, required: true }) subtitle!: string;
  @Prop({ type: Array, default: () => [] }) tasks!: ITask[];
  @Prop({ type: Object, required: false }) agency!: IAgency;
  @Prop({ type: Object, required: true }) taskCounts!: ITaskCountsResult;

  activeTab: '7' | '30' = '7';
  isDropdownOpen = false;

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectTab(tab: '7' | '30') {
    this.activeTab = tab;
    this.isDropdownOpen = false;
  }

  get recentTasks(): ITask[] {
    const daysAgo = this.activeTab === '7' ? 7 : 30;
    const cutoffDate = dayjs().subtract(daysAgo, 'day').startOf('day');
    return this.tasks.filter((task) => {
      return dayjs(task.createdAt).isAfter(cutoffDate);
    });
  }

  get completedTasks(): ITask[] {
    return this.recentTasks.filter((task) => task.status === TaskStatus.COMPLETED);
  }

  get openTasks(): ITask[] {
    return this.recentTasks.filter((task) => task.status === TaskStatus.TODO);
  }

  get overdueTasks(): ITask[] {
    return this.recentTasks.filter((task) => {
      if (!task.dueAt) return false;
      return dayjs(task.dueAt).isBefore(dayjs(), 'day');
    });
  }

  get completionPercentage(): number {
    if (this.recentTasks.length === 0) return 0;
    return Math.round((this.completedTasks.length / this.recentTasks.length) * 100);
  }

  get series(): number[] {
    return [this.completionPercentage];
  }

  chartOptions = {
    chart: {
      height: 270,
      type: 'radialBar',
    },
    plotOptions: {
      radialBar: {
        size: 150,
        offsetY: 20,
        startAngle: -150,
        endAngle: 150,
        hollow: {
          size: '65%',
        },
        track: {
          background: '#F0F0F1',
          strokeWidth: '100%',
        },
        dataLabels: {
          name: {
            offsetY: -15,
            fontSize: '1rem',
          },
          value: {
            offsetY: 5,
            fontSize: '2.25rem',
          },
        },
      },
    },
    colors: ['#3A7BC7'],
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'light',
        type: 'horizontal',
        shadeIntensity: 0.5,
        gradientToColors: ['#00b5b5'],
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 100],
      },
    },
    stroke: {
      dashArray: 8,
    },
    labels: ['Erledigt'],
  };
}
